const EMAIL = 'operations@carbonsafe.earth'

function mailtoLink(subject: string, body: string): string {
  return `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export const MAILTO = {
  /* ── Generic ── */
  demo: mailtoLink(
    'CarbonSafe Platform Demo Request',
    'Hello CarbonSafe team,\n\nI would like to schedule a demo of the CarbonSafe platform.\n\nName: \nOrganisation: \nRole: \nPhone: \nBest time to call: \n\nThank you',
  ),
  expert: mailtoLink(
    'CarbonSafe Expert Consultation Request',
    'Hello,\n\nI would like to speak with a CarbonSafe expert.\n\nName: \nOrganisation: \nRole: \nTopic of interest: \nPhone: \n\nThank you',
  ),
  platformAccess: mailtoLink(
    'CarbonSafe Platform Access Request',
    'Hello,\n\nI would like to explore the CarbonSafe platform.\n\nName: \nOrganisation: \nRole: \nPrimary use case: \n\nThank you',
  ),
  caseStudy: mailtoLink(
    'CarbonSafe Case Study Request',
    'Hello,\n\nI would like to receive a CarbonSafe case study.\n\nName: \nOrganisation: \nIndustry / vertical of interest: \n\nThank you',
  ),
  contact: mailtoLink(
    'General Enquiry — CarbonSafe',
    'Hello,\n\nI would like to get in touch with the CarbonSafe team.\n\nName: \nOrganisation: \nEnquiry: \n\nThank you',
  ),

  /* ── GHG & ESG Reporting ── */
  ghgDemo: mailtoLink(
    'GHG & ESG Reporting — Demo Request',
    "Hello,\n\nI am interested in CarbonSafe's GHG accounting and ESG reporting platform.\n\nName: \nOrganisation: \nIndustry: \nRole: \nKey reporting frameworks needed (IFRS S1/S2, CSRD, CBAM, GHG Protocol): \nPhone: \n\nThank you",
  ),
  ghgPlatform: mailtoLink(
    'GHG & ESG Platform — Access Request',
    'Hello,\n\nI would like to explore the CarbonSafe GHG and ESG reporting platform.\n\nName: \nOrganisation: \nIndustry: \nRole: \nCurrent reporting challenges: \n\nThank you',
  ),
  complianceGuide: mailtoLink(
    'Uganda ESG Compliance Guide Request',
    'Hello,\n\nI would like to receive the Uganda ESG Compliance Guide.\n\nName: \nOrganisation: \nRole: \nPrimary compliance concern (CBAM / CSRD / GHG Protocol / Uganda Climate Change Act): \n\nThank you',
  ),
  ghgCaseStudy: mailtoLink(
    'GHG Accounting Case Study Request',
    'Hello,\n\nI would like to receive a GHG accounting case study.\n\nName: \nOrganisation: \nIndustry: \n\nThank you',
  ),

  /* ── CBAM ── */
  cbamDemo: mailtoLink(
    'CBAM Compliance — Demo Request',
    "Hello,\n\nI am interested in CarbonSafe's CBAM compliance solution.\n\nName: \nOrganisation: \nRole: \nExported products (cement / steel / aluminium / fertilizers / other): \nAnnual EU export value (approx): \n\nThank you",
  ),
  cbamCaseStudy: mailtoLink(
    'CBAM Case Study Request',
    'Hello,\n\nI would like to receive a CBAM compliance case study.\n\nName: \nOrganisation: \nExported products: \n\nThank you',
  ),

  /* ── CSRD ── */
  csrdDemo: mailtoLink(
    'EU CSRD Reporting — Demo Request',
    "Hello,\n\nI am interested in CarbonSafe's CSRD compliance solution.\n\nName: \nOrganisation: \nRole: \nEU parent company or key EU buyer: \nPrimary ESRS topics of concern: \n\nThank you",
  ),
  csrdCaseStudy: mailtoLink(
    'CSRD Case Study Request',
    'Hello,\n\nI would like to receive a CSRD compliance case study.\n\nName: \nOrganisation: \nEU parent company or buyer: \n\nThank you',
  ),

  /* ── Coffee Traceability ── */
  coffeeDemo: mailtoLink(
    'Coffee Traceability & EUDR — Demo Request',
    "Hello,\n\nI am interested in CarbonSafe's coffee traceability and EUDR compliance platform.\n\nName: \nOrganisation: \nRole in supply chain (exporter / processor / cooperative / buyer): \nAnnual export volume (approx bags or tonnes): \nKey EU markets: \n\nThank you",
  ),
  coffeePlatform: mailtoLink(
    'Coffee Traceability Platform — Access Request',
    'Hello,\n\nI would like to explore the CarbonSafe coffee traceability platform.\n\nName: \nOrganisation: \nRole: \nNumber of farms / farmers in your supply chain: \n\nThank you',
  ),
  coffeeCaseStudy: mailtoLink(
    'Coffee Traceability Case Study Request',
    'Hello,\n\nI would like to receive a coffee traceability case study.\n\nName: \nOrganisation: \nRole: \n\nThank you',
  ),
  coffeeChecklist: mailtoLink(
    'EUDR Compliance Checklist — Download Request',
    'Hello,\n\nI would like to receive the EUDR Compliance Checklist for Ugandan coffee exporters.\n\nName: \nOrganisation: \nRole: \nAnnual EU export volume (approx): \n\nThank you',
  ),
  coffeeReport: mailtoLink(
    'Uganda Coffee EUDR Report Request',
    'Hello,\n\nI would like to receive the full Uganda coffee EUDR compliance report.\n\nName: \nOrganisation: \nRole: \n\nThank you',
  ),

  /* ── Cookstove Credits ── */
  cookstoveDemo: mailtoLink(
    'Cookstove Carbon Credits — Demo Request',
    "Hello,\n\nI am interested in CarbonSafe's cookstove carbon credit dMRV solution.\n\nName: \nOrganisation: \nRole (project developer / NGO / distributor / investor): \nEstimated cookstove units or target households: \nCarbon registry of interest (Gold Standard / Verra VCS): \n\nThank you",
  ),
  cookstovePlatform: mailtoLink(
    'Cookstove dMRV Platform — Access Request',
    'Hello,\n\nI would like to explore the CarbonSafe cookstove dMRV platform.\n\nName: \nOrganisation: \nRole: \nProject stage (planning / active / scaling): \n\nThank you',
  ),
  cookstoveProject: mailtoLink(
    'Cookstove Carbon Credit Project Enquiry',
    'Hello,\n\nI would like to start a cookstove carbon credit project with CarbonSafe.\n\nName: \nOrganisation: \nRole: \nTarget geography: \nEstimated households: \nTimeline: \n\nThank you',
  ),
  cookstoveCaseStudy: mailtoLink(
    'Cookstove Carbon Credits Case Study Request',
    'Hello,\n\nI would like to receive a cookstove carbon credits case study.\n\nName: \nOrganisation: \nRole: \n\nThank you',
  ),

  /* ── Training & Courses ── */
  enrollCourse: mailtoLink(
    'Course Enrollment Enquiry',
    'Hello,\n\nI would like to enroll in a CarbonSafe certification program.\n\nName: \nOrganisation: \nRole: \nProgram of interest: \nPreferred delivery format (in-person / online / hybrid): \nPreferred start date: \nNumber of participants: \n\nThank you',
  ),
  courseSyllabus: mailtoLink(
    'Course Syllabus Request',
    'Hello,\n\nI would like to receive the course syllabus.\n\nName: \nOrganisation: \nRole: \nProgram of interest: \n\nThank you',
  ),
  corporateCohort: mailtoLink(
    'Corporate Training Proposal Request',
    'Hello,\n\nI would like to request a corporate training proposal.\n\nInstitution: \nContact name & role: \nProgram(s) of interest: \nNumber of participants: \nPreferred delivery format (in-person / online / hybrid): \nPreferred dates: \nSpecific regulatory focus: \n\nThank you',
  ),
  enterpriseProposal: mailtoLink(
    'Enterprise Training Proposal Request',
    'Hello,\n\nI would like to request an enterprise training proposal for my institution.\n\nInstitution: \nContact name & role: \nProgram(s) of interest: \nNumber of participants: \nPreferred delivery format: \nRegulatory obligations to address: \n\nThank you',
  ),
  trainingBrochure: mailtoLink(
    'Training Brochure Request',
    'Hello,\n\nI would like to receive the CarbonSafe training brochure.\n\nName: \nOrganisation: \nRole: \nPrograms of interest: \n\nThank you',
  ),
  regulatoryUpdates: mailtoLink(
    'Regulatory Update Subscription Request',
    "Hello,\n\nI would like to subscribe to CarbonSafe's monthly regulatory compliance updates.\n\nName: \nOrganisation: \nRole: \nFrameworks of interest (CSRD / CBAM / PCAF / Uganda Climate Change Act / all): \n\nThank you",
  ),
  trainingContact: mailtoLink(
    'Training Team Contact Request',
    'Hello,\n\nI would like to speak with the CarbonSafe training team.\n\nName: \nOrganisation: \nRole: \nEnquiry: \n\nThank you',
  ),
  corporateTraining: mailtoLink(
    'Corporate Training Enquiry',
    'Hello,\n\nI would like to discuss corporate training options for my institution.\n\nInstitution: \nContact name & role: \nNumber of participants: \nPrograms of interest: \nTimeline: \n\nThank you',
  ),

  /* ── About / Careers ── */
  careers: mailtoLink(
    'Career Enquiry — CarbonSafe',
    'Hello,\n\nI am interested in joining the CarbonSafe team.\n\nName: \nRole / area of expertise: \nLinkedIn profile: \nCurrent location: \nBrief introduction: \n\nThank you',
  ),
  aboutContact: mailtoLink(
    'Contact CarbonSafe',
    'Hello,\n\nI would like to get in touch with the CarbonSafe team.\n\nName: \nOrganisation: \nRole: \nEnquiry: \n\nThank you',
  ),

  /* ── Presentation ── */
  presentationDemo: mailtoLink(
    'CarbonSafe Demo Request — Presentation',
    'Hello,\n\nI viewed the CarbonSafe presentation and would like to schedule a demo.\n\nName: \nOrganisation: \nRole: \nPhone: \nArea of interest (coffee / cookstoves / forestry / agroforestry / energy / GHG reporting): \n\nThank you',
  ),
  downloadDeck: mailtoLink(
    'CarbonSafe Pitch Deck Request',
    'Hello,\n\nI would like to receive the CarbonSafe pitch deck.\n\nName: \nOrganisation: \nRole: \nContext (investor / partner / buyer / other): \n\nThank you',
  ),

  /* ── Footer ── */
  footerContact: mailtoLink(
    'Contact CarbonSafe',
    'Hello,\n\nI would like to get in touch.\n\nName: \nOrganisation: \nEnquiry: \n\nThank you',
  ),
  footerDemo: mailtoLink(
    'CarbonSafe Demo Request',
    'Hello,\n\nI would like to book a demo of the CarbonSafe platform.\n\nName: \nOrganisation: \nRole: \nPhone: \n\nThank you',
  ),
  footerPartners: mailtoLink(
    'Partnership Enquiry — CarbonSafe',
    'Hello,\n\nI am interested in a partnership with CarbonSafe.\n\nName: \nOrganisation: \nRole: \nPartnership type: \n\nThank you',
  ),
  footerCareers: mailtoLink(
    'Career Enquiry — CarbonSafe',
    'Hello,\n\nI am interested in joining the CarbonSafe team.\n\nName: \nRole / expertise: \nLinkedIn: \n\nThank you',
  ),
  footerPrivacy: mailtoLink(
    'Privacy Policy Enquiry — CarbonSafe',
    "Hello,\n\nI have a question about CarbonSafe's privacy policy.\n\nName: \nEnquiry: \n\nThank you",
  ),
  footerTerms: mailtoLink(
    'Terms of Service Enquiry — CarbonSafe',
    "Hello,\n\nI have a question about CarbonSafe's terms of service.\n\nName: \nEnquiry: \n\nThank you",
  ),
}
